/*
    1W: 5th element
    2W: 10th element
    1M: 21st element
    3M: 63rd element
    6M: 126th element

    because 1 week is 5 trading days and 1 month is 21
  */

export const getHorizonToIndexMap = (offset = 0) =>
  new Map<string, number>([
    ['1d', 1 + offset],
    ['1w', 5 + offset],
    ['2w', 10 + offset],
    ['1m', 21 + offset],
    ['2m', 42 + offset],
    ['3m', 63 + offset],
    ['4m', 84 + offset],
    ['5m', 105 + offset],
    ['6m', 126 + offset],
    ['1y', 252 + offset],
    ['12m', 252 + offset],
  ]);

export const getDefaultSelectedHorizon = (
  horizons: string[],
  bestHorizon?: string
) => {
  if (bestHorizon && horizons.includes(bestHorizon)) {
    return bestHorizon;
  }

  return horizons.at(-1);
};

export const getHorizonSelectionKey = (
  horizons: string[],
  bestHorizon?: string,
  resetKey?: string
) =>
  `${bestHorizon ?? ''}:${horizons.join(',')}${resetKey ? `:${resetKey}` : ''}`;

export const getActiveHorizonIndex = (
  horizons: string[],
  selectedHorizon?: string
) => {
  if (!selectedHorizon) {
    return 0;
  }

  const index = horizons.indexOf(selectedHorizon);
  return index === -1 ? 0 : index;
};

export const getTranslatedHorizonToIndex = (
  horizons: string[],
  rawHorizonToIndex: Map<string, number>,
  translateHorizon: (horizon: string) => string
) => {
  const horizonToIndex = new Map<string, number>();

  horizons.forEach(horizon => {
    const indexValue = rawHorizonToIndex.get(horizon);
    if (indexValue !== undefined) {
      horizonToIndex.set(translateHorizon(horizon), indexValue);
    }
  });

  return horizonToIndex;
};

const getHorizonsUpToIndex = (
  horizons: string[],
  endIndex: number,
  horizonToIndex: Map<string, number>
) =>
  horizons.filter(horizon => {
    const index = horizonToIndex.get(horizon);
    return index !== undefined && index <= endIndex;
  });

export const clipPriceMovementToHorizon = <TPoint, TSnake>({
  prediction,
  snakeTs,
  horizons,
  selectedHorizon,
  horizonToIndex,
}: {
  prediction: TPoint[];
  snakeTs: TSnake[];
  horizons: string[];
  selectedHorizon?: string;
  horizonToIndex: Map<string, number>;
}) => {
  if (!selectedHorizon || prediction.length === 0) {
    return { prediction, snakeTs, horizons };
  }

  const selectedIndex = horizonToIndex.get(selectedHorizon);
  if (selectedIndex === undefined) {
    return { prediction, snakeTs, horizons };
  }

  const endIndex = Math.min(selectedIndex, prediction.length - 1);

  return {
    prediction: prediction.slice(0, endIndex + 1),
    snakeTs: snakeTs.slice(0, endIndex + 1),
    horizons: getHorizonsUpToIndex(horizons, endIndex, horizonToIndex),
  };
};
